import React from "react";
import "./waitingUserBox.scss";

import { Stack } from "react-bootstrap";

import ClearIcon from "@mui/icons-material/Clear";
import CheckIcon from "@mui/icons-material/Check";
import { confirmSubscriptionShiftWS } from "../../api/shiftDetailsApi";

export const WaitingUserBox = ({
  name,
  surname,
  idUserShift,
  imageProfile,
  handleClick,
}) => {
  return (
    <div className="waiting-user-box">
      <Stack
        direction="horizontal"
        className="d-flex justify-content-between"
        gap={3}
      >
        <Stack direction="horizontal" gap={3}>
          <img src={imageProfile} alt="profile image" />
          <span>{name + " " + surname}</span>
        </Stack>
        <Stack direction="horizontal" gap={2}>
          <div
            className="icon-accept-reject"
            onClick={() => handleClick(idUserShift, false)}
          >
            <ClearIcon
              style={{ color: "red", width: "30px", height: "30px" }}
            />
          </div>
          <div
            className="icon-accept-reject"
            onClick={() => handleClick(idUserShift, true)}
          >
            <CheckIcon
              style={{ color: "green", width: "30px", height: "30px" }}
            />
          </div>
        </Stack>
      </Stack>
    </div>
  );
};
